module.exports = __webpack_public_path__ + "img/82_Istoriia_a_Alexandrului_celui_Mare_din_Machedoniia_Movilau_1796_foaie_de_titlu.69d0cb89.png";